import React from "react";

const Account = () => {
    return (
        <div style={{ textAlign: "center" }}>This feature is coming soon!</div>
    );
};

export default Account;
